import * as React from 'react';
import './index.scss';
import { IGoodsCard } from 'types/goods';
import {
    isPreHeating,
    getTagImg,
    inActivity,
    sellOut,
    computePrice,
    canUseCoupon,
    getSellText
} from 'services/goods/process-goods-card';
import openLink from 'libs/open-link';
import { sendEvent } from 'libs/event';
import { SellOut } from '../sell-out/index';
import Image from 'components/common/image';
import { openProductDetail } from 'src/services/pageControl';

export interface IGoodsCardProps {
    goods: IGoodsCard;
    size?: 'l' | 'xl';
    eventExtra?: any;
    selfDescription?: string;
    stopGoGoodsDetail?: boolean;
    handleOtherClick?: (goods: IGoodsCard) => void;
    beforeClickGoods?: (url: string, goods: IGoodsCard, position: number) => string;
}
export function getTitleLabel(goods: IGoodsCard, length: number = 8) {
    if (!goods.activity_tags) return null;
    const labels = goods.activity_tags.filter((item) => item.type === 'normal');
    if (labels.length) {
        return labels.map((label) => (
            <span
                key={label.title}
                className="goods-card__name--label"
                style={{ background: label.mainColor }}
            >
                {label.title && label.title.slice(0, length)}
            </span>
        ));
    }
    return null;
}
const maxLabelLen = {
    default: 15,
    l: 20,
    xl: 25
};
export function getSecondLabel(goods: IGoodsCard, maxLen?: number) {
    if (!goods.activity_tags) return null;
    const labels = goods.activity_tags.filter((item) => item.type === 'other');
    if (labels.length) {
        return labels.map((label, index) => {
            const fontLabels = labels
                .slice(0, index + 1)
                .map((item) => item.label)
                .join('');
            if (maxLen && fontLabels.length > maxLen) {
                return '';
            }
            return (
                <span
                    key={label.label}
                    className="goods-card__info-label goods-card__info-promotion"
                >
                    {label.label}
                </span>
            );
        });
    }
    return null;
}

export function Card(props: IGoodsCardProps) {
    let hasClicked = false;

    function clickGoodsEvent(goods: IGoodsCard) {
        let extra: any = {
            goods_id: goods.goods_id,
            ...props.eventExtra
        };
        if (goods.req_id) {
            extra.fxg_req_id = goods.req_id;
        }
        sendEvent('click_goods', extra);
    }
    function showCouponText(goods: IGoodsCard) {
        let labels = '';
        if (goods.activity_tags) {
            labels = goods.activity_tags
                .filter((item) => item.type === 'other')
                .map((item) => item.label)
                .join('');
        }
        if (!props.size) {
            if (!labels.length) {
                return props.goods.coupon_label.length <= 15;
            }
            return props.goods.coupon_label.length + labels.length < 13;
        }
        if (props.size === 'xl') {
            if (!labels.length) {
                return props.goods.coupon_label.length <= 20;
            }
            return props.goods.coupon_label.length + labels.length < 18;
        }
        if (props.size === 'l') {
            if (!labels.length) {
                return props.goods.coupon_label.length <= 25;
            }
            return props.goods.coupon_label.length + labels.length < 23;
        }

        return true;
    }
    function clickGoods(_position: number, goods: IGoodsCard) {
        hasClicked = true;

        if (props.stopGoGoodsDetail && props.handleOtherClick) {
            props.handleOtherClick(props.goods);
        } else {
            clickGoodsEvent(goods);
            openProductDetail({ id: goods.goods_id, options: props.eventExtra });
        }
    }
    return (
        <div
            className={`goods-card ${hasClicked ? 'goods-card--clicked' : ''} ${
                props.size ? 'goods-card-' + props.size : ''
            }`}
            onClick={() => clickGoods(1, props.goods)}
        >
            <div className="goods-card__img">
                <Image src={props.goods.image} className="goods-card__img--main"></Image>
                {getTagImg(props.goods, 0) && inActivity(props.goods) && (
                    <img
                        className="goods-card__img--tag-top"
                        src={getTagImg(props.goods, 0)}
                        alt="标签"
                    />
                )}
                {getTagImg(props.goods, 1) && inActivity(props.goods) && (
                    <img
                        className="goods-card__img--tag-bottom"
                        src={getTagImg(props.goods, 1)}
                        alt="标签"
                    />
                )}
                {sellOut(props.goods) && <SellOut />}
            </div>
            <div className="goods-card__main">
                <div className="goods-card__name">
                    <span className="goods-card__name--text">
                        {getTitleLabel(props.goods)}
                        {props.goods.goods_name}
                    </span>
                </div>
                <div className="goods-card__info">
                    {getSecondLabel(
                        props.goods,
                        props.size ? maxLabelLen[props.size] : maxLabelLen.default
                    )}
                    {canUseCoupon(props.goods) && showCouponText(props.goods) ? (
                        <span className="goods-card__info-label goods-card__info-coupon">
                            <i className="goods-card__info-coupon-label">券</i>
                            <span className="goods-card__info-coupon-text">
                                {props.goods.coupon_label.replace('券', '')}
                            </span>
                        </span>
                    ) : null}
                </div>
                <div className="goods-card__other">
                    <span className="goods-card__other-price">
                        <span className="goods-card__other-price--label">¥</span>
                        {props.goods.show_price
                            ? props.goods.show_price / 100
                            : computePrice(props.goods)}
                    </span>
                    <span>{getSellText(props.goods)}</span>
                </div>
            </div>
        </div>
    );
}
